/* eslint-disable new-cap */
/* eslint-disable camelcase */
import ContainerUtils from '@abcya/abcya_phaser/src/js/Utils/GameObjects/ContainerUtils';
import Phaser from 'phaser';
import gameData from '../gameData';
import AudioPlayer from '../library/AudioPlayer';
import Tweener from '../library/Tweener';
import BasicSprite from '../objects/BasicSprite';
import BonusMeteor from '../objects/Bonus/BonusMeteor';
import BonusTimer from '../objects/Bonus/BonusTimer';
import City from '../objects/Bonus/City';
import MeteorCounter from '../objects/Bonus/MeteorCounter';
import ProgressMeter from '../objects/Game/ProgressMeter';
import InstructionsBox from '../objects/InstructionsBox';
import MenuButton from '../objects/MenuButton';
import SoundButton from '../objects/SoundButton';
import StarField from '../objects/StarField';
import DoorScene from './DoorScene';
import MenuPopup from './MenuPopup';
import Win from './Win';
import ABCyaPhaser, { Audio } from '@abcya/abcya_phaser';
import ABCyaLib from '@abcya/abcya_lib';

export default class Bonus extends Phaser.Scene {
  static get KEY() {return 'Bonus';}

  create() {
    this.background = new BasicSprite(this, this.scale.width * .5, this.scale.height * .5, 'bonusBackground');
    this.add.existing(this.background);

    this.starField = new StarField(this);

    this.city = new City(this);
    this.add.existing(this.city);
    this.city.Display();

    this.progressMeter = new ProgressMeter(this, 6);
    this.progressMeter.SetLevel(6);

    this.menuButton = new MenuButton(this, 'menuButton', 'menuButton_Depressed', () => {this.eh_MenuButton_Clicked();});
    this.soundButton = new SoundButton(this, this.scale.width - 60, 60);

    this.meteorCounter = new MeteorCounter(this);
    this.add.existing(this.meteorCounter);

    this.bonusTimer = new BonusTimer(this, () => {this.eh_Result(ABCyaPhaser.Localization.instance.getLocalizedString('times_up'));});
    this.add.existing(this.bonusTimer);

    this.maxMeteors = 30;
    this.spawningSpeed_Min = 800;
    this.spawningSpeed_Max = 2000;
    this.spawningSpeed = this.spawningSpeed_Max;
    this.meteorSpeed_Min = 150;
    this.meteorSpeed_Max = 300;
    this.meteorSpeed = this.meteorSpeed_Min;
    this.popUpExists = false;

    this.meteors = [];
    gameData.meteorsDestroyed = 0;
    this.isPaused = true;
    this.spawnTimer = this.time.addEvent({ delay: this.spawningSpeed, loop: true, callback: () => {this.spawnMeteor();} });
    this.spawnTimer.loop = true;

    this.result_Text = this.add.bitmapText(this.scale.width * .5, this.scale.height * .5, 'Nasalization', '', 70);
    this.result_Text.setOrigin(.5);
    this.result_Text.setScale(0);

    this.TogglePause(true);

    this.instructions = new InstructionsBox(this, ABCyaPhaser.Localization.instance.getLocalizedString('bonus_game_instructions'), () => {this.eh_InstructionsClosed();});
    this.add.existing(this.instructions);
    this.instructions.Display();

    AudioPlayer.PlaySound(this, AudioPlayer.sounds.CLICK_METEOR, false, 1, Audio.LOCALIZATION_AUDIO_SPRITE);
  }

  eh_InstructionsClosed() {
    this.TogglePause(false);
    this.time.addEvent({ delay: 500, callback: () => this.spawnMeteor() });
  }

  eh_MenuButton_Clicked() {
    AudioPlayer.PlaySound(this, AudioPlayer.sounds.CLICK);

    this.scene.run(MenuPopup.KEY, { sceneFrom: Bonus.KEY });
  }

  eh_Result(text) {
    this.TogglePause(true);
    this.result_Text.text = text;
    Tweener.To(this.result_Text, { scale: 1 }, 500, Phaser.Math.Easing.Back.Out);
    const timer = this.time.addEvent({ delay: 1500, callback: () => {this.eh_Result_TimedOut();} });
    timer.paused = false;
    timer.loop = false;
  }

  // After the times up popup goes away
  eh_Result_TimedOut() {
    if (!this.popUpExists) {
      this.menuButton.button.disableInteractive();
      this.soundButton.button.button.disableInteractive();
      this.popUpExists = true;
      Tweener.To(this.result_Text, { scale: 0 }, 500, Phaser.Math.Easing.Circular.Out);
      Tweener.To(this.result_Text, { alpha: 0 }, 500, Phaser.Math.Easing.None);
      const text1 = gameData.meteorsDestroyed > 0 ? `${ABCyaPhaser.Localization.instance.getLocalizedString('result_popup.wow')}\n${ABCyaPhaser.Localization.instance.getLocalizedString('result_popup.you_have_collected')}` : ABCyaPhaser.Localization.instance.getLocalizedString('result_popup.you_didnt_collect');
      let text2;
      switch (gameData.meteorsDestroyed) {
        case 0:
          text2 = ABCyaPhaser.Localization.instance.getLocalizedString('result_popup.please_try_again');
          break;
        case 1:
          text2 = `${ABCyaLib.Environment.instance.gameConfig.spaceRocksPrefix}1 ${ABCyaPhaser.Localization.instance.getLocalizedString('result_popup.space_rock')}!`;
          break;
        default:
          text2 = `${ABCyaLib.Environment.instance.gameConfig.spaceRocksPrefix}${gameData.meteorsDestroyed} ${ABCyaPhaser.Localization.instance.getLocalizedString('result_popup.space_rocks')}!`;
          break;
      }
      this.instructions = new InstructionsBox(this, text1, () => {this.eh_ResultsClosed();}, text2);
      this.add.existing(this.instructions);
      this.instructions.Display();
    }
  }

  eh_ResultsClosed() {
    this.scene.get(DoorScene.KEY).changeScene(Bonus.KEY, Win.KEY);
  }

  spawnMeteor() {
    if (this.isPaused) return;

    const meteor = new BonusMeteor(this, 100 + (Math.random() * (this.scale.width - 200)), -50);
    this.add.existing(meteor.sprite);
    meteor.SetFallingSpeed(this.meteorSpeed);
    const sprite = meteor.GetSprite();

    this.children.moveBelow(meteor.sprite, this.progressMeter.progressPoints[0]);
    ContainerUtils.setContainerInteractive(sprite);
    sprite.on('pointerdown', () => {this.meteorSelected(meteor);});

    this.meteors.push(meteor);
  }

  TogglePause(toggle) {
    const fallingSpeed = toggle ? 0 : this.meteorSpeed;
    this.spawnTimer.paused = toggle;
    this.bonusTimer.TogglePause(toggle);
    this.isPaused = toggle;

    for (let i = 0; i < this.meteors.length; i++) {
      this.meteors[i].SetFallingSpeed(fallingSpeed);
    }
  }

  meteorSelected(meteor) {
    if (this.isPaused) return;

    gameData.meteorsDestroyed++;

    meteor.Explode();
    meteor.GetSprite().disableInteractive();
    this.meteors.splice(this.meteors.indexOf(meteor), 1);
    this.meteorCounter.SetCount(gameData.meteorsDestroyed);

    this.cameras.main.shake(0.0005, 600);
    this.time.addEvent(meteor.GetParticleLifeSpan(), () => {meteor.GetSprite().destroy();});
    this.adjustDifficulty();
  }

  adjustDifficulty() {
    const totalTime = this.bonusTimer.gameTime;
    const timeLeft = this.bonusTimer.curTime;
    const meteorsDestroyed = gameData.meteorsDestroyed;
    const difficultyAdjustment = ((meteorsDestroyed / this.maxMeteors) * 1) + ((1 - (timeLeft / totalTime)) * 0);

    this.spawningSpeed = (this.spawningSpeed_Max - this.spawningSpeed_Min) * (1 - difficultyAdjustment);
    this.meteorSpeed = ((this.meteorSpeed_Max - this.meteorSpeed_Min) * difficultyAdjustment) + this.meteorSpeed_Min;

    if (this.spawningSpeed < this.spawningSpeed_Min) this.spawningSpeed = this.spawningSpeed_Min;
    if (this.meteorSpeed > this.meteorSpeed_Max) this.meteorSpeed = this.meteorSpeed_Max;

    for (let i = 0; i < this.meteors.length; i++) {
      this.meteors[i].SetFallingSpeed(this.meteorSpeed);
    }
    this.spawnTimer.delay = this.spawningSpeed;
  }

  lose() {
    this.TogglePause(true);
    this.city.Destroy();
    this.eh_Result(ABCyaPhaser.Localization.instance.getLocalizedString('game_over'));
  }

  update() {
    this.instructions.Update();
    for (let i = 0; i < this.meteors.length; i++) {
      const meteor = this.meteors[i];
      if (meteor.sprite.y >= (this.scale.height - 100)) {
        this.meteors.splice(this.meteors.indexOf(meteor), 1);
        meteor.Explode();
        this.lose();
      }
    }
  }
}
